import { FEATURES_HOME_URL_RUNTIME_ENV } from '.';
import { RUNTIME_ENV } from '@shared/utils/dev-server.helper';
import { CALILIO_NODE_ENV } from './env';

export const FEATURES_HOME_URL =
  FEATURES_HOME_URL_RUNTIME_ENV[RUNTIME_ENV as CALILIO_NODE_ENV] ||
  FEATURES_HOME_URL_RUNTIME_ENV[CALILIO_NODE_ENV.DEVELOP];
